<template>
  <div class="allnews-page">
    <Article />
    <br />
  </div>
</template>

<script>
import Article from "@/components/public/pages/blog/article5";

export default {
  name: "LimeLoansCompanyNewspage",

  components: { Article },

  metaInfo: {
    meta: [
      {
        name: "facebook-domain-verification",
        content: process.env.VUE_APP_FACEBOOK_DOMAIN_VERIFICATION,
      },
    ],
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
//
</style>
